import React from 'react'

import { Outlet } from 'react-router-dom'

export function AdvanceLayout() {
    return <Outlet />
}

export default AdvanceLayout